module.exports = __webpack_public_path__ + "static/media/backgroundNBA_Dark.452cf227.svg";